import { createContext } from 'react';

const TableSessionContext = createContext(null);

export default TableSessionContext;
